{
  "Accessibility menu": "Barrierefreiheits-Menü",
  "Close": "Schließen",
  "Content adjustments": "Inhaltsanpassungen",
  "Navigation adjustments": "Navigationsanpassungen",
  "Align Left": "Links ausrichten",
  "Adjust Font Size": "Schriftgröße anpassen",
  "Highlight Title": "Titel hervorheben",
  "Highlight Links": "Links hervorheben",
  "Readable Font": "Lesbare Schriftart",
  "Colour adjustments": "Farbanpassungen",
  "Dark Contrast": "Dunkler Kontrast",
  "Light Contrast": "Heller Kontrast",
  "High Contrast": "Hoher Kontrast",
  "High Saturation": "Hohe Sättigung",
  "Low Saturation": "Niedrige Sättigung",
  "Monochrome": "Monochrom",
  "Tools": "Werkzeuge",
  "Reading Guide": "Leseführung",
  "Big Cursor": "Großer Cursor",
  "Increase Font Size": "Schriftgröße vergrößern",
  "Decrease Font Size": "Schriftgröße verkleinern",
  "Letter Spacing": "Buchstabenabstand",
  "Line Height": "Zeilenhöhe",
  "Font Weight": "Schriftschnitt",
  "Dyslexia Font": "Legasthenie-Schriftart",
  "Language": "Sprache",
  "Accessibility widget": "Barrierefreiheits-Menü öffnen",
  "Accessibility Profiles": "Barrierefreiheits-Profile",
  "Cognitive Disability": "Kognitive Beeinträchtigung",
  "Seizure Safe": "Anfallssicher",
  "Accessibility statement": "Barrierefreiheits-Erklärung",
  "ADHD": "ADHD",
  "Low Vision": "Low Vision",
  "Pause Animations": "Animationen stoppen",
  "Reset all settings": "Einstellungen Zurücksetzen",
  "Shortcut:": "Shortcut:"
}
